// 大廳語系表：整份抄自原版 lobby bundle（index-5b9d1850.js）裡編譯好的 vue-i18n messages，
// 對應原始碼 src/plugin/locale.ts 的 zh-tw / zh-cn / en / vn / th / tr 六個語系。
export type AvailableLocales = 'zh-tw' | 'zh-cn' | 'en' | 'vn' | 'th' | 'tr';

type Messages = Record<string, string>;

export const MESSAGES: Record<AvailableLocales, Messages> = {
  'zh-tw': {
    最新: '最新', 熱門: '熱門', 遊戲搜尋: '遊戲搜尋', 開始遊戲: '開始遊戲',
    '權限驗證錯誤，請重新登入': '權限驗證錯誤，請重新登入',
    noData: '沒有資料', comingSoon: '敬請期待',
    'categories.all': '全部遊戲', 'categories.slot': '電子', 'categories.arcade': '街機',
    'categories.poker': '棋牌', 'categories.lottery': '彩票',
  },
  'zh-cn': {
    最新: '最新', 熱門: '热门', 遊戲搜尋: '游戏搜索', 開始遊戲: '开始游戏',
    '權限驗證錯誤，請重新登入': '权限验证错误，请重新登录',
    noData: '没有资料', comingSoon: '敬请期待',
    'categories.all': '全部游戏', 'categories.slot': '电子', 'categories.arcade': '街机',
    'categories.poker': '棋牌', 'categories.lottery': '彩票',
  },
  en: {
    最新: 'Latest', 熱門: 'Popular', 遊戲搜尋: 'Search games', 開始遊戲: 'Play',
    '權限驗證錯誤，請重新登入': 'Authorization error, please log in again.',
    noData: 'No data.', comingSoon: 'Coming Soon',
    'categories.all': 'All', 'categories.slot': 'Slot', 'categories.arcade': 'Arcade',
    'categories.poker': 'Poker', 'categories.lottery': 'Lottery',
  },
  vn: {
    最新: 'Mới nhất', 熱門: 'Phổ biến', 遊戲搜尋: 'Tìm kiếm trò chơi', 開始遊戲: 'Bắt đầu chơi',
    '權限驗證錯誤，請重新登入': 'Lỗi xác thực quyền, vui lòng đăng nhập lại',
    noData: 'No data.', comingSoon: 'Coming Soon',
    'categories.all': 'All', 'categories.slot': 'Slot', 'categories.arcade': 'Arcade',
    'categories.poker': 'Poker', 'categories.lottery': 'Lottery',
  },
  th: {
    最新: 'ล่าสุด', 熱門: 'ยอดนิยม', 遊戲搜尋: 'ค้นหาเกม', 開始遊戲: 'เริ่มเกม',
    '權限驗證錯誤，請重新登入': 'การยืนยันสิทธิ์ล้มเหลว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    noData: 'ไม่มีข้อมูล', comingSoon: 'เร็ว ๆ นี้',
    'categories.all': 'เกมทั้งหมด', 'categories.slot': 'สล็อต', 'categories.arcade': 'อาร์เคด',
    'categories.poker': 'โป๊กเกอร์', 'categories.lottery': 'ลอตเตอรี่',
  },
  tr: {
    最新: 'En Yeni', 熱門: 'Popüler', 遊戲搜尋: 'Oyun Ara', 開始遊戲: 'Oyunu Başlat',
    '權限驗證錯誤，請重新登入': 'Yetki doğrulama hatası, lütfen tekrar giriş yapın',
    noData: 'No data.', comingSoon: 'Coming Soon',
    'categories.all': 'All', 'categories.slot': 'Slot', 'categories.arcade': 'Arcade',
    'categories.poker': 'Poker', 'categories.lottery': 'Lottery',
  },
};

export const AVAILABLE: AvailableLocales[] = ['zh-tw', 'zh-cn', 'en', 'vn', 'th', 'tr'];

export let locale: AvailableLocales = 'zh-tw';

export function setLocale(l: string | null | undefined) {
  locale = (AVAILABLE as string[]).includes(l ?? '') ? (l as AvailableLocales) : 'zh-tw';
}

/** vue-i18n 的 $t：找不到就退回 zh-tw（原版 fallbackLocale）。 */
export function t(key: string): string {
  return MESSAGES[locale][key] ?? MESSAGES['zh-tw'][key] ?? key;
}
